<template>
  <div class="float-l w-200" style="line-height: 60px">
    <span class="font-small text-white">{{ name }}</span>
    <el-dropdown @command="handleCommand" >
      <i class="el-icon-arrow-down el-icon--right text-white"></i>
      <el-dropdown-menu slot="dropdown" :hide-on-click="false">
       <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {remove} from '@/utils/sessionStorage'
export default {
  name: "UserOpt",
  computed: {
    ...mapGetters([
      'name',
      'phone',
    ]),
  },
  methods:{
    handleCommand(command){
       if(command==="userCenter"){
          this.$router.push("/user/center")
       }
       if(command==="logout"){
         this.$store.dispatch('LogOut').then(() => {
           location.href = '/login';
         })
         remove("visitViews");
      }
    }
  }
}
</script>

<style scoped>

</style>
